/* A picture at full size over the page (T735; decision 1476): the dimmed page behind, the picture at its own size in a room that scrolls both ways, the caption beneath, and the × at the top right. */
.backdrop {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  background: var(--overlay-backdrop);
}

.close {
  position: absolute;
  top: var(--space-3);
  right: var(--space-3);
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: var(--tap-target-min);
  min-height: var(--tap-target-min);
  padding: 0;
  border: none;
  border-radius: var(--radius-small);
  background: var(--surface);
  color: var(--text);
  cursor: pointer;
}

.close:focus-visible {
  outline: var(--focus-ring);
  outline-offset: var(--focus-ring-offset);
}

.room {
  flex: 1;
  display: flex;
  overflow: auto;
  padding: var(--space-6) var(--space-4);
}

/* The figure centres itself while it fits and starts at the room's corner once it is larger, so every edge of a large picture scrolls into view. */
.figure {
  margin: auto;
  padding: var(--space-2);
  background: var(--surface);
  border-radius: var(--radius-small);
}

/* The picture's own size: the column's cap and the picture's minimum width (decision 1476) do not reach it here. */
.picture {
  display: block;
  max-width: none;
  min-width: 0;
  height: auto;
}

.caption {
  margin-top: var(--space-2);
  font-size: var(--font-size-small);
  color: var(--text-muted);
}
